import { jsx as _jsx } from "react/jsx-runtime";
import { Center, Container, Flex, Link } from '@chakra-ui/react';
import Image from 'next/image';
const DEFAULT_COLOR_CONFIG = {
    container: { bg: '#333333' },
    active: { bg: '#0000115c' },
    inactive: { bg: 'transparent' },
    hover: { bg: '#00001126' },
};
const DEFAULTS = {
    height: '40px',
    align: 'flex-start',
    brandContainerProps: {
        h: '100%',
        minW: '50px',
        px: 4,
        py: 2,
    },
};
export const BrandPicker = (props) => {
    const { sites, currentBrand, backgroundColor = DEFAULT_COLOR_CONFIG.container.bg, height = DEFAULTS.height, align = DEFAULTS.align, brandContainerProps, } = props;
    const brandContainer = {
        ...DEFAULTS.brandContainerProps,
        ...brandContainerProps,
    };
    sites?.sort((a, b) => (a?.order || 0) - (b?.order || 0));
    return (_jsx(Flex, { alignContent: "center", bg: backgroundColor, height: height, children: _jsx(Container, { maxW: "container.xl", children: _jsx(Flex, { justifyContent: align, alignContent: "center", h: "full", children: sites?.map((site) => {
                    const active = site.key === currentBrand;
                    let brandPickerLogo = active
                        ? site?.brandLogoSmall || site?.brandLogo
                        : site?.brandLogo || site?.brandLogoSmall;
                    if (!site ||
                        !site.url ||
                        !site.displayMultiBrandBanner ||
                        !brandPickerLogo) {
                        return null;
                    }
                    return (_jsx(Link, { href: site.url, bg: active
                            ? DEFAULT_COLOR_CONFIG.active.bg
                            : DEFAULT_COLOR_CONFIG.inactive.bg, _hover: {
                            ...(!active && { ...DEFAULT_COLOR_CONFIG.hover }),
                        }, children: _jsx(Center, { ...brandContainer, children: _jsx(Image, { src: brandPickerLogo.url, width: active ? '30px' : '100px', height: "25px", objectFit: "contain", priority: true }) }) }, site.key));
                }) }) }) }));
};
